import { useEffect, useState } from "react";
import modelService from "../services/modelService";

const useGetModel = <T>(path: string, id: string | number | null | undefined) => {
	const [data, setData] = useState<T | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const getData = async () => {
			if (id) {
				setLoading(true);

				try {
					const result = await modelService.readModel<T>(`${path}/${id}`);
					setData(result);
				} catch (error) {
					setError(error as Error);
				} finally {
					setLoading(false);
				}
			}
		};

		getData();
	}, [id, path]);

	return { data, loading, error };
};

export default useGetModel;
